import { render, staticRenderFns } from "./BuildDetails.vue?vue&type=template&id=2e24c5f4&scoped=true&"
import script from "./BuildDetails.vue?vue&type=script&lang=js&"
export * from "./BuildDetails.vue?vue&type=script&lang=js&"
import style0 from "./BuildDetails.vue?vue&type=style&index=0&id=2e24c5f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e24c5f4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VChip,VContainer,VIcon,VProgressCircular,VRow})
